import React, { Component } from 'react'
import '../../CSS/global.css'
import ReusableButton from '../../SharedComponents/Button/Button'
import ReusableTextBox from '../../SharedComponents/Textbox/Textbox'
import './datatables.css'
import * as CleanersDashboardHomeConstant from './CleanersDashboardHomeConstant'
import { Redirect } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import moment from "moment";
import { IoMdSearch, IoMdArrowRoundUp, IoMdArrowRoundDown } from "react-icons/io"
import DashboardCleanerLogo from '../../SharedComponents/DashboardCleanerLogo/DashboardCleanerLogo'
import DashboardCleanersHeader from '../Shared/DashboardCleanersHeader/DashboardCleanersHeader'
import Chart from "chart.js"
import { VendorCleaners } from '../../CleanersDashboardAPI/CleanersDashboardVendorCleanersAPI'
import Loading from '../../Images/loading.gif'
import { isIE } from 'react-device-detect';
import { VendorSuccessCleans } from '../../CleanersDashboardAPI/CleanersDashboardVendorSuccesCleansAPI'
import { VendorMissedCleans } from '../../CleanersDashboardAPI/CleanersDashboardVendorMissedCleansApi'
import { VendorDownloadCSVMissedCleans } from '../../CleanersDashboardAPI/CleanersDashboardDownloadCSVAPI'
import { VendorDownloadCSVSuccessCleans } from '../../CleanersDashboardAPI/CleanersDashboardSuccesCleanCSVapi'
import { Link } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import './CleanersDashboardHome.css'
const FileDownload = require('js-file-download');

const $ = require('jquery')
$.DataTable = require('datatables.net')

class CleanersDashboardHome extends Component {
    constructor(props) {
        super();
        this.state = {
            attendedCleans: false,
            missedCleans: false,
            visitorTypesList: [],
            arrayVisitorBackgroundColour: [],
            arrayVisitorCount: [],
            Page: "1",
            SearchParameters: "",
            SearchParametersMissedCleans: "",
            pageCount: '',
            pageCountMissedCleans: '',
            compliantFirePolicy: false,
            SelectedStoreId: '',
            paginationNoDisplay: false,
            redirectError400: false,
            redirectError401: false,
            redirectError404: false,
            redirectError500: false,
            redirectNoData: false,
            highValueDisplay: false,
            flagDiffMissedClean: true,
            MissedCleansClicked: false,
            PageMissedCleans: "1",
            paginationNoDisplayMissedCleans: false,
            SelectedStartDate: '',
            SelectedEndDate: '',
            downloadCSVdisable : false,
            downloadCSVdisableMissed : false
           
        }
        this.pageCount = "";
        this.ViewReport = this.ViewReport.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchMissedCleans = this.handleSearchMissedCleans.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageChangeMissedCleans = this.handlePageChangeMissedCleans.bind(this);
        this.loadPieChart = this.loadPieChart.bind(this);
        this.handleChangeSearch = this.handleChangeSearch.bind(this);
        this.downloadCSVMissedCleans = this.downloadCSVMissedCleans.bind(this);
    }


    handleSearch(e) {
        this.setState({
            Page: 1
        })
        let UserId = sessionStorage.getItem('userId'),
            StoreId = sessionStorage.getItem('selectedStore'),
            StartDate = moment(sessionStorage.getItem('startDate')).format('YYYY-MM-DD'),
            EndDate = moment(sessionStorage.getItem('endDate')).format('YYYY-MM-DD'),
            Page = this.state.Page,
            PageMissedCleans="",
            SearchParametersMissedCleans="",
            Login = "",
            SearchParameters = this.state.SearchParameters

        this.loadPieChart(UserId,StoreId,StartDate,EndDate,Page,PageMissedCleans,SearchParametersMissedCleans,SearchParameters,Login)
    }

    handleSearchMissedCleans(e) {
        this.setState({
            PageMissedCleans: 1,
            MissedCleansClicked: true
        })
        let UserId = sessionStorage.getItem('userId'),
            StoreId = sessionStorage.getItem('selectedStore'),
            StartDate = moment(sessionStorage.getItem('startDate')).format('YYYY-MM-DD'),
            EndDate = moment(sessionStorage.getItem('endDate')).format('YYYY-MM-DD'),
            // StartDate = moment(sessionStorage.getItem('startDate')).format('MMM DD, YYYY'),
            // EndDate = moment(sessionStorage.getItem('endDate')).format('MMM DD, YYYY'),
            Page="",
            PageMissedCleans = this.state.PageMissedCleans,
            Login = "",
            SearchParametersMissedCleans = this.state.SearchParametersMissedCleans,
            SearchParameters=""

        this.loadPieChart(UserId,StoreId,StartDate,EndDate,Page,PageMissedCleans,SearchParametersMissedCleans,SearchParameters,Login)
    }

    ViewReport() {
        this.setState({
            Page: 1,
            loading: true
        })
        let UserId = sessionStorage.getItem('userId'),
            StoreId = sessionStorage.getItem('selectedStore'),
            StartDate = moment(sessionStorage.getItem('startDate')).format('YYYY-MM-DD'),
            EndDate = moment(sessionStorage.getItem('endDate')).format('YYYY-MM-DD'),
            Page = 1,
            PageMissedCleans = 1,
            SearchParametersMissedCleans = this.state.SearchParametersMissedCleans,
            SearchParameters =this.state.SearchParameters,
            Login=""
            // StartDate =moment(StartDate).format('YYYY-MM-DD')
            // EndDate =moment(EndDate).format('YYYY-MM-DD')
        this.loadPieChart(UserId, StoreId,StartDate,EndDate,Page,PageMissedCleans,SearchParametersMissedCleans,SearchParameters,Login)
    }
    downloadCSV() {
        this.setState({
            loading: true
        })
        var startOnLoad = moment().subtract(6, "days")
        var endDateOnLoad = moment()
        let AuthData = {
            UserId: sessionStorage.getItem('userId'),
            StoreId: sessionStorage.getItem('selectedStore'),
            StartDate: moment(sessionStorage.getItem('startDate')).format('YYYY-MM-DD'),
            EndDate: moment(sessionStorage.getItem('endDate')).format('YYYY-MM-DD'),
            Page: 0,
            Login: "",
            SearchParameters: this.state.SearchParameters
        }
        if (AuthData.StoreId == "" || AuthData.StoreId == null) {
            AuthData.StoreId = CleanersDashboardHomeConstant.DashBoardVisitorId;
        }
        if (AuthData.StartDate == "" || AuthData.StartDate == null) {
            AuthData.StartDate = startOnLoad;
        }
        if (AuthData.EndDate == "" || AuthData.EndDate == null) {
            AuthData.EndDate = endDateOnLoad;
        }
        if(isIE) {
            if (AuthData.StartDate == "" || AuthData.StartDate == null) {
                AuthData.StartDate = moment(startOnLoad).format('YYYY-MM-DD')
            }
            if (AuthData.EndDate == "" || AuthData.EndDate == null) {
                AuthData.EndDate = moment(endDateOnLoad).format('YYYY-MM-DD')
            }      
        }
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        VendorDownloadCSVSuccessCleans(AuthData, AuthStr).then(res => {
            if (res.status == 200) {
                this.setState({
                    loading: false
                })
                FileDownload(res.data, 'SuccessCleansReport.csv');
            }
            else if (res.status == 400) {
                this.setState({
                    redirectError400: true,
                    loading: false
                })
            }
            else if (res.status == 401) {
                this.setState({
                    redirectError401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                this.setState({
                    redirectError404: true,
                    loading: false
                })
            }
            else if (res.status == 500) {
                this.setState({
                    redirectError500: true,
                    loading: false
                })
            }

        })
    }

    downloadCSVMissedCleans() {
        this.setState({
            loading: true
        })
        let startOnLoad = moment().subtract(6, "days")
        let endDateOnLoad = moment()
        let AuthData = {
            UserId: sessionStorage.getItem('userId'),
            StoreId: sessionStorage.getItem('selectedStore'),
            StartDate: moment(sessionStorage.getItem('startDate')).format('YYYY-MM-DD'),
            EndDate: moment(sessionStorage.getItem('endDate')).format('YYYY-MM-DD'),
            Page: 0,
            SearchParameters: this.state.SearchParametersMissedCleans
        }
        if (AuthData.StoreId == "" || AuthData.StoreId == null) {
            AuthData.StoreId = CleanersDashboardHomeConstant.DashBoardVisitorId;
        }
        if (AuthData.StartDate == "" || AuthData.StartDate == null) {
            AuthData.StartDate = startOnLoad;
        }
        if (AuthData.EndDate == "" || AuthData.EndDate == null) {
            AuthData.EndDate = endDateOnLoad;
        }
        if(isIE) {
            if (AuthData.StartDate == "" || AuthData.StartDate == null) {
                AuthData.StartDate = moment(startOnLoad).format('YYYY-MM-DD')
            }
            if (AuthData.EndDate == "" || AuthData.EndDate == null) {
                AuthData.EndDate = moment(endDateOnLoad).format('YYYY-MM-DD')
            }      
        }
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        VendorDownloadCSVMissedCleans(AuthData, AuthStr).then(res => {
            if (res.status == 200) {
                this.setState({
                    loading: false
                })
                FileDownload(res.data, 'MissedCleansReport.csv');
            }
            else if (res.status == 400) {
                this.setState({
                    redirectError400: true,
                    loading: false //comment added
                })
            }
            else if (res.status == 401) {
                this.setState({
                    redirectError401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                this.setState({
                    redirectError404: true,
                    loading: false
                })
            }
            else if (res.status == 500) {
                this.setState({
                    redirectError500: true,
                    loading: false
                })
            }

        })
    }
    handleChangeSearch = (e) => {
        this.setState({
            SearchParameters: e.target.value
        })

    }
    handleChangeSearchMissedCleans = (e) => {
        this.setState({
            SearchParametersMissedCleans: e.target.value
        })

    }

    handlePageChangeMissedCleans(e) {
        let selected = e.selected + 1
        this.setState({
            PageMissedCleans: selected,
            MissedCleansClicked: true
        })

        let UserId = sessionStorage.getItem('userId'),
            StoreId = sessionStorage.getItem('selectedStore'),
            StartDate = moment(sessionStorage.getItem('startDate')).format('YYYY-MM-DD'),
            EndDate = moment(sessionStorage.getItem('endDate')).format('YYYY-MM-DD'),
            PageMissedCleans = selected,
            Page="",
            Login = "",
            SearchParametersMissedCleans = this.state.SearchParametersMissedCleans,
            SearchParameters=""
        this.loadPieChart(UserId,StoreId,StartDate,EndDate,Page,PageMissedCleans,Login,SearchParameters,SearchParametersMissedCleans);
    }

    handlePageChange(e) {
        let selected = e.selected + 1
        this.setState({
            Page: selected
        })
        let UserId = sessionStorage.getItem('userId'),
            StoreId = sessionStorage.getItem('selectedStore'),
            StartDate = moment(sessionStorage.getItem('startDate')).format('YYYY-MM-DD'),
            EndDate = moment(sessionStorage.getItem('endDate')).format('YYYY-MM-DD'),
            Page = selected,
            PageMissedCleans="",
            Login = "",
            SearchParameters = this.state.SearchParameters,
            SearchParametersMissedCleans=""
            this.loadPieChart(UserId,StoreId,StartDate,EndDate,Page,PageMissedCleans,Login,SearchParameters,SearchParametersMissedCleans);
    }
    componentWillMount() {
        if (sessionStorage.getItem('token')) {
            var role = sessionStorage.getItem('role')
            var Name = sessionStorage.getItem('name')
            
            var SelectedStoreId = sessionStorage.getItem('selectedStore')
            this.setState({
                SelectedStoreId: SelectedStoreId,
                role: role,
               
            })
            this.setState({
                Name: Name,
                SelectedStartDate: sessionStorage.getItem('startDate'),
                SelectedEndDate: sessionStorage.getItem('endDate')
            })
            let UserId = sessionStorage.getItem('userId'),
                StoreId = 0,
                StartDate =  this.state.SelectedStartDate,
                EndDate =   this.state.SelectedEndDate,
                Page = 1,
                PageMissedCleans = "",
                Login = "",
                SearchParameters = "",
                SearchParametersMissedCleans = ""
               
            this.loadPieChart(UserId,StoreId,StartDate,EndDate,Page,PageMissedCleans,Login,SearchParameters,SearchParametersMissedCleans);
        }
        else {
            this.setState({
                redirectLogin: true
            })
        }
    }
    componentWillUnmount() {
        sessionStorage.removeItem('startDate')
        sessionStorage.removeItem('endDate')
        // sessionStorage.removeItem('selectedStore')
    }
    componentDidMount() {
        $("#MissedClean").hide();
        $('.MissedCleanersNavTab').removeClass('selected');
        $('.AttendedCleanersNavTab').removeClass('selected');
        $('.AttendedCleanersNavTab').addClass('selected');
        var self = this;
        $(".AttendedCleanersNavTab").click(function (e) {
            e.preventDefault();
            $('.MissedCleanersNavTab').removeClass('selected');
            $('.AttendedCleanersNavTab').removeClass('selected');
            $(this).addClass('selected');
            $("#MissedClean").hide()
            $("#AttendedClean").show();
            self.setState({
                MissedCleansClicked: false,
                Page: 1
            })
       let  UserId = sessionStorage.getItem('userId'),
            StoreId = sessionStorage.getItem('selectedStore'),
            StartDate = sessionStorage.getItem('startDate'),
            EndDate = sessionStorage.getItem('endDate'),
            PageMissedCleans = "",
            Page= 1,
            SearchParametersMissedCleans= "",
            SearchParameters=self.state.SearchParameters,
            Login=""
            if (StoreId == "" || StoreId == null) {
                StoreId = CleanersDashboardHomeConstant.DashBoardVisitorId;
            }
            self.loadPieChart(UserId,StoreId,StartDate,EndDate,Page,PageMissedCleans,SearchParametersMissedCleans,SearchParameters,Login)

        })
        var self = this;
        $(".MissedCleanersNavTab").click(function (e) {
            e.preventDefault();
            $('.AttendedCleanersNavTab').removeClass('selected');
            $('.MissedCleanersNavTab').removeClass('selected');
            $(this).addClass('selected');
            $("#AttendedClean").hide();
            $("#MissedClean").show();

            let UserId = sessionStorage.getItem('userId'),
                StoreId = sessionStorage.getItem('selectedStore'),
                StartDate = moment(sessionStorage.getItem('startDate')).format('YYYY-MM-DD'),
                EndDate = moment(sessionStorage.getItem('endDate')).format('YYYY-MM-DD'),
                PageMissedCleans = 1,
                Page="",
                SearchParametersMissedCleans= self.state.SearchParametersMissedCleans,
                SearchParameters="",
                Login=""
                if (StoreId == "" || StoreId == null) {
                    StoreId = CleanersDashboardHomeConstant.DashBoardVisitorId;
                }
            self.setState({
                MissedCleansClicked: true,
                PageMissedCleans: 1
            })
            self.loadPieChart(UserId,StoreId,StartDate,EndDate,Page,PageMissedCleans,SearchParametersMissedCleans,SearchParameters,Login)
        })
    }
    handleSearchEnter = (e) => {
        if (e.key == 'Enter') {
            this.handleSearch();
        }
    }
    handleSearchEnterMissedCleans = (e) => {
        if (e.key == 'Enter') {
            this.handleSearchMissedCleans();
        }
    }
    loadPieChart(UserId,StoreId,StartDate,EndDate,Page,PageMissedCleans,SearchParametersMissedCleans,SearchParameters,Login) {
        this.setState({
            loading: true
        })
        let AuthData = {
            UserId: UserId,
            StoreId: StoreId,
            StartDate: StartDate,
            EndDate: EndDate,
            Page: Page,
            PageMissedCleans : PageMissedCleans,
            SearchParametersMissedCleans : SearchParametersMissedCleans,
            SearchParameters: SearchParameters,
            Login: Login
        }
       
         let startOnLoad = moment().subtract(6, "days")
         let endDateOnLoad = moment()

        //  let startOnLoadTemp = moment().subtract(6, "days") 
        //  let startOnLoad = startOnLoadTemp.format("YYYY-MM-DD");
        //  let endDateOnLoad = moment().format("YYYY-MM-DD");
        // var d = new Date()
        // var yDate = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).getDate()
        // var yMonth = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).getMonth() + 1
        // var yYear = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).getFullYear()
        // let finalStartDate = yYear + '-' + yMonth + '-' + yDate
        // let finalEndDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + (d.getDate())
        let arrayVisitorType = [];
        let arrayVisitorCount = [];
        let visitorTypesList = [];
        let arrayLineChartLabels = [];
        let arrayLineChartData = [];
        let arrayLineChartDataUpdated = [];
        let arrayLineChartLabelsUpdated = [];
        let arrayVisitorBackgroundColour = [];
        if (AuthData.StoreId == "" || AuthData.StoreId == null) {
            AuthData.StoreId = CleanersDashboardHomeConstant.DashBoardVisitorId;
        }
        if (AuthData.StartDate == "" || AuthData.StartDate == null) {
            AuthData.StartDate = startOnLoad;
        }
        if (AuthData.EndDate == "" || AuthData.EndDate == null) {
            AuthData.EndDate = endDateOnLoad;
        }
        if(isIE) {
            if (AuthData.StartDate == "" || AuthData.StartDate == null) {
                AuthData.StartDate = moment(startOnLoad).format('YYYY-MM-DD')
            }
            if (AuthData.EndDate == "" || AuthData.EndDate == null) {
                AuthData.EndDate = moment(endDateOnLoad).format('YYYY-MM-DD')
            }      
        }
        let AuthDataCharts = {
            UserId: AuthData.UserId,
            StoreId: AuthData.StoreId,
            StartDate: AuthData.StartDate,
            EndDate: AuthData.EndDate
        }
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        VendorCleaners(AuthDataCharts, AuthStr).then(res => {
            let responseJSON = res;
            if (responseJSON.status == 200) {
                let res = responseJSON.data.visitorCount
                let responsediffMissedClean = responseJSON.data.missedCleans.diffMissedClean;
                let responsemissedCleans = responseJSON.data.missedCleans.missedCleans;
                if (responsediffMissedClean == 'High Value') {
                    this.setState({
                        highValueDisplay: true
                    })
                }
                else {
                    this.setState({
                        highValueDisplay: false
                    })
                }
                if (responsediffMissedClean < 0) {
                    this.setState({
                        flagDiffMissedClean: false
                    })
                }
                else {
                    this.setState({
                        flagDiffMissedClean: true
                    })
                }
                this.setState({
                    diffMissedClean: responsediffMissedClean,
                    missedCleans: responsemissedCleans,
                 

                })
                let responseLineChart = responseJSON.data.missedCleans.lineChart
                if (res.length == 0) {           /* Cleaners Type Chart Count*/
                    this.setState({
                        redirectNoData: true
                    })
                }
                else {
                    this.setState({
                        redirectNoData: false
                    })
                }
                Object.keys(res).forEach(function (key) {
                    arrayVisitorType.push({
                        VisitorType: res[key].visitorType, Count: res[key].count,
                    })
                });
                arrayVisitorType.map((x) => {
                    arrayVisitorCount.push(x.Count)

                    if (x.VisitorType === 2) {
                        visitorTypesList.push(CleanersDashboardHomeConstant.chartLabelCleaners)
                        arrayVisitorBackgroundColour.push(CleanersDashboardHomeConstant.CleanersColor)
                    }
                    if (x.VisitorType === 8) {
                        visitorTypesList.push(CleanersDashboardHomeConstant.chartLabelCleaningManager)
                        arrayVisitorBackgroundColour.push(CleanersDashboardHomeConstant.CleaningManagerColor)
                    }
                    if (x.VisitorType === 9) {
                        visitorTypesList.push(CleanersDashboardHomeConstant.chartLabelCleaningAuditor)
                        arrayVisitorBackgroundColour.push(CleanersDashboardHomeConstant.CleaningAuditorColor)
                    }
                })
                this.setState({
                    arrayVisitorBackgroundColour : arrayVisitorBackgroundColour,
                    visitorTypesList : visitorTypesList,
                    arrayVisitorCount : arrayVisitorCount
                })
                /* Doughnut Chart */
                var config = {
                    type: 'doughnut',
                    data: {
                        labels: this.state.visitorTypesList,
                        datasets: [{
                            backgroundColor: this.state.arrayVisitorBackgroundColour,
                            data: this.state.arrayVisitorCount
                        }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            display: true,
                            position: "right",
                            labels: {
                                boxWidth: 14,
                                padding: 8,
                                fontSize: 13
                            }
                        }
                    }
                }
                var ChartVisitor = document.getElementById('PieChart')
                ChartVisitor.innerHTML = '&nbsp;';
                $('#PieChart').append('<canvas id="pieChartType"></canvas>');
                var ctx = $('#pieChartType').get(0).getContext("2d");
                ctx.width = 1000;
                ctx.height = 1000;
                var myChart = new Chart(ctx, config);

                Object.keys(responseLineChart).forEach(function (key) {
                    arrayLineChartLabels.push({
                        Labels: responseLineChart[key].key, ChartType: responseLineChart[key].chartType
                    })
                    arrayLineChartData.push({
                        Data: responseLineChart[key].count
                    })
                })
                arrayLineChartLabels.map((x) => {
                    if ((x.ChartType == 2)) {   /*  Monthly Data*/
                        if (x.Labels == 1 || x.Labels == 13) {
                            x.Labels = CleanersDashboardHomeConstant.Jan
                        }
                        else if (x.Labels == 2 || x.Labels == 14) {
                            x.Labels = CleanersDashboardHomeConstant.Feb
                        }
                        else if (x.Labels == 3 || x.Labels == 15) {
                            x.Labels = CleanersDashboardHomeConstant.Mar
                        }
                        else if (x.Labels == 4 || x.Labels == 16) {
                            x.Labels = CleanersDashboardHomeConstant.Apr
                        }
                        else if (x.Labels == 5 || x.Labels == 17) {
                            x.Labels = CleanersDashboardHomeConstant.May
                        }
                        else if (x.Labels == 6 || x.Labels == 18) {
                            x.Labels = CleanersDashboardHomeConstant.Jun
                        }
                        else if (x.Labels == 7 || x.Labels == 19) {
                            x.Labels = CleanersDashboardHomeConstant.Jul
                        }
                        else if (x.Labels == 8 || x.Labels == 20) {
                            x.Labels = CleanersDashboardHomeConstant.Aug
                        }
                        else if (x.Labels == 9 || x.Labels == 21) {
                            x.Labels = CleanersDashboardHomeConstant.Sep
                        }
                        else if (x.Labels == 10 || x.Labels == 22) {
                            x.Labels = CleanersDashboardHomeConstant.Oct
                        }
                        else if (x.Labels == 11 || x.Labels == 23) {
                            x.Labels = CleanersDashboardHomeConstant.Nov
                        }
                        else if (x.Labels == 12 || x.Labels == 24) {
                            x.Labels = CleanersDashboardHomeConstant.Dec
                        }
                        arrayLineChartLabelsUpdated.push(x.Labels)
                    }
                    else if (x.ChartType == 1) {       /*  Daily Data*/
                        var month = new Array();
                        month[0] = CleanersDashboardHomeConstant.January;
                        month[1] = CleanersDashboardHomeConstant.February;
                        month[2] = CleanersDashboardHomeConstant.March;
                        month[3] = CleanersDashboardHomeConstant.April;
                        month[4] = CleanersDashboardHomeConstant.May;
                        month[5] = CleanersDashboardHomeConstant.June;
                        month[6] = CleanersDashboardHomeConstant.July;
                        month[7] = CleanersDashboardHomeConstant.August;
                        month[8] = CleanersDashboardHomeConstant.September;
                        month[9] = CleanersDashboardHomeConstant.October;
                        month[10] = CleanersDashboardHomeConstant.November;
                        month[11] = CleanersDashboardHomeConstant.December;
                        var d = new Date(x.Labels);
                        var n = d.getDate() + " " + month[d.getMonth()] + " " + d.getFullYear();
                        x.Labels = n;
                        arrayLineChartLabelsUpdated.push(x.Labels)
                    }
                    else if (x.ChartType == 3) {
                        arrayLineChartLabelsUpdated.push(x.Labels)    /*  Yearly Data*/
                    }
                })
                arrayLineChartData.map((x) => {
                    arrayLineChartDataUpdated.push(x.Data)
                })
                /* LineChart */
                var data = {
                    type: 'line',
                    data: {
                        labels: arrayLineChartLabelsUpdated,
                        datasets: [{
                            fill: false,
                            lineTension: 0.1,
                            backgroundColor: "rgba(75,192,192,0.4)",
                            borderColor: "rgba(75,192,192,1)",
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: "rgba(75,192,192,1)",
                            pointBackgroundColor: "#fff",
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: "rgba(75,192,192,1)",
                            pointHoverBorderColor: "rgba(220,220,220,1)",
                            pointHoverBorderWidth: 2,
                            pointRadius: 5,
                            pointHitRadius: 10,
                            data: arrayLineChartDataUpdated
                        }
                        ]
                    },
                    options: {
                        showLines: true,
                        legend: {
                            display: false,
                            position: "right",
                            labels: {
                                boxWidth: 40,
                                padding: 11
                            }
                        }
                    }
                }

                var lineChartId = document.getElementById('LineGraphChart')
                lineChartId.innerHTML = '&nbsp;';
                $('#LineGraphChart').append('<canvas id="lineChartType"></canvas>');
                var ctx = $('#lineChartType').get(0).getContext("2d");
                var myChart = new Chart(ctx, data);
            }
            else if (responseJSON.status == 400) {
                this.setState({
                    redirectError400: true,
                    loading: false
                })
            }
            else if (responseJSON.status == 401) {
                this.setState({
                    redirectError401: true,
                    loading: false
                })
            }
            else if (responseJSON.status == 404) {
                this.setState({
                    redirectError404: true,
                    loading: false
                })
            }
            else if (responseJSON.status == 500) {
                this.setState({
                    redirectError500: true,
                    loading: false
                })
            }
        })

     
        let AuthDataAPISuccessCleans = {
            UserId: AuthData.UserId,
            StoreId: AuthData.StoreId,
            StartDate: AuthData.StartDate,
            EndDate: AuthData.EndDate,
            Page: Page,
            Login: "",
            SearchParameters: this.state.SearchParameters
        }
        let arrayVisitorData = [];
        if (!(this.state.MissedCleansClicked)) {                                                                       /* Clicked Attended*/
            VendorSuccessCleans(AuthDataAPISuccessCleans, AuthStr).then(res => {
                let responseJSON = res;
                if (responseJSON.status == 200) {
                    this.pageCount = responseJSON.data.visitors.pageCount
                    // this.setState({
                    //     pageCount: responseJSON.data.visitors.pageCount
                    // })
                    if (responseJSON.data.visitors.pageCount == 0) {
                        this.setState({
                            paginationNoDisplay: true
                        })
                    }
                    else {
                        this.setState({
                            paginationNoDisplay: false
                        })
                    }
                   
                    let responseDataVisitor = responseJSON.data.visitors.visitorList
                    Object.keys(responseDataVisitor).forEach(function (key) {
                        arrayVisitorData.push({
                            Store: responseDataVisitor[key].visitor.store.name, Visitor: responseDataVisitor[key].visitor.name,
                            PurposeForVisit: responseDataVisitor[key].visitor.reason, FireCompliance: responseDataVisitor[key].visitor.firePolicyAcceptance,
                            AsbestosCompliance: responseDataVisitor[key].visitor.asbestosAcceptance, Date: responseDataVisitor[key].visitor.checkInTime,
                            TimeIn: responseDataVisitor[key].visitor.checkInTime.substring(11, 19), TimeOut: responseDataVisitor[key].visitor.checkOutTime.substring(11, 19),
                            CompanyName: responseDataVisitor[key].visitor.companyName, VisitorType: responseDataVisitor[key].visitor.visitorType, InStore: responseDataVisitor[key].inStore,
                        })
                    });
                    if(responseDataVisitor.length == 0) {
                        this.setState({
                            downloadCSVdisable : true
                        })
                    }
                    else {
                        this.setState({
                            downloadCSVdisable : false
                        })
                    }
                    arrayVisitorData.map((x) => {
                        if (x.FireCompliance === true) {
                            x.FireCompliance = CleanersDashboardHomeConstant.FirePolicy
                            this.setState({
                                compliantFirePolicy: true
                            })
                        }
                        if (x.AsbestosCompliance === true) {
                            x.FireCompliance = x.FireCompliance + '\n' + CleanersDashboardHomeConstant.Asbestos
                        }
                        var month = new Array();
                        month[0] = CleanersDashboardHomeConstant.January;
                        month[1] = CleanersDashboardHomeConstant.February;
                        month[2] = CleanersDashboardHomeConstant.March;
                        month[3] = CleanersDashboardHomeConstant.April;
                        month[4] = CleanersDashboardHomeConstant.May;
                        month[5] = CleanersDashboardHomeConstant.June;
                        month[6] = CleanersDashboardHomeConstant.July;
                        month[7] = CleanersDashboardHomeConstant.August;
                        month[8] = CleanersDashboardHomeConstant.September;
                        month[9] = CleanersDashboardHomeConstant.October;
                        month[10] = CleanersDashboardHomeConstant.November;
                        month[11] = CleanersDashboardHomeConstant.December;
                        var d = new Date(x.Date);
                        var n = d.getDate() + " " + month[d.getMonth()] + " " + d.getFullYear();
                        x.Date = n;
                        x.Visitor = x.Visitor + ' (' + x.CompanyName + ')'
                        if (x.PurposeForVisit == null) {
                            x.PurposeForVisit = ''
                        }
                        if (x.VisitorType === 2) {
                            x.PurposeForVisit = x.PurposeForVisit + CleanersDashboardHomeConstant.BracketCleaningServices
                        }
                        if (x.VisitorType === 8) {
                            x.PurposeForVisit = x.PurposeForVisit + CleanersDashboardHomeConstant.BracketCleaningManager
                        }
                        if (x.VisitorType === 9) {
                            x.PurposeForVisit = x.PurposeForVisit + CleanersDashboardHomeConstant.BracketCleaningAuditor
                        }
                        if (x.InStore === 1) {
                            x.TimeOut = 'In Store Now'
                        }
                    })
                    $(document).ready(function () {
                        $('#example').DataTable({
                            searching: false,
                            paging: false,
                            data: arrayVisitorData,
                            destroy: true,
                            sort: false,
                            columnDefs: [{
                                //  orderSequence:["desc"], targets:[4],

                                type: 'date', 'targets': [4],
                                order: [[4, 'desc']],
                                targets: 6,
                                render: function (data, type, full, meta) {
                                    if (data === "In Store Now") {
                                        return '<td><p class="InStoreNow">In store</p><td>'
                                    }
                                    else {
                                        return data;
                                    }
                                }
                            }
                            ],
                            "columns": [
                                { "data": "Store" },
                                { "data": "Visitor" },
                                { "data": "PurposeForVisit" },
                                { "data": "FireCompliance" },
                                { "data": "Date" },
                                { "data": "TimeIn" },
                                { "data": "TimeOut" }
                            ]
                        })
                    })
                    this.setState({
                        loading: false
                    })
                }
                else if (responseJSON.status == 400) {
                    this.setState({
                        redirectError400: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 401) {
                    this.setState({
                        redirectError401: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 404) {
                    this.setState({
                        redirectError404: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 500) {
                    this.setState({
                        redirectError500: true,
                        loading: false
                    })
                }
            })
        }
        else {
            let startOnLoadMC = moment(startOnLoad).format('YYYY-MM-DD')
            let endOnLoadMC = moment(endDateOnLoad).format('YYYY-MM-DD')
            let AuthDataAPIMissedCleans = {        /*Clicked Missed Cleans Tab*/
                UserId: UserId,
                StoreId: AuthData.StoreId,
                StartDate: startOnLoadMC,
                EndDate: endOnLoadMC,
                Page: PageMissedCleans,
                Login: "",
                SearchParameters: this.state.SearchParametersMissedCleans
            }
            let arrayMissedCleanVisitorData = [];
            VendorMissedCleans(AuthDataAPIMissedCleans, AuthStr).then(res => {
                if (res.status == 200) {
                    this.setState({
                        pageCountMissedCleans: res.data.visitors.pageCount
                    })
                    if (res.data.visitors.pageCount == 0) {
                        this.setState({
                            paginationNoDisplayMissedCleans: true
                        })
                    }
                    else {
                        this.setState({
                            paginationNoDisplayMissedCleans: false
                        })
                    }
                    let responseMissedCleanVisitor = res.data.visitors.data
                    Object.keys(responseMissedCleanVisitor).forEach(function (key) {
                        arrayMissedCleanVisitorData.push({
                            HubId: responseMissedCleanVisitor[key].hubId, HubName: responseMissedCleanVisitor[key].hubName,
                            SupplierName: responseMissedCleanVisitor[key].supplierName,
                            Date: responseMissedCleanVisitor[key].date.split("T")[0]
                        })
                    });
                    if(responseMissedCleanVisitor.length == 0) {
                        this.setState({
                            downloadCSVdisableMissed : true
                        })
                    }
                    else {
                        this.setState({
                            downloadCSVdisableMissed : false
                        })
                    }
                    $(document).ready(function () {
                        $('#exampleMissedClean').DataTable({
                            searching: false,
                            paging: false,
                            data: arrayMissedCleanVisitorData,
                            destroy: true,
                            sort: false,
                            columnDefs: [{
                                type: 'date', 'targets': [3],
                                order: [[3, 'desc']]
                            }],
                            "columns": [
                                { "data": "HubId" },
                                { "data": "HubName" },
                                { "data": "SupplierName" },
                                { "data": "Date" }
                            ],
                        })
                    })
                    this.setState({
                        loading: false
                    })
                }
            })

        }
    }

    render() {
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        if (this.state.redirectError400) {
            return (<Redirect to={'/CleanersDashboardError400'} />)
        }
        if (this.state.redirectError401) {
            return (<Redirect to={'/CleanersDashboardError401'} />)
        }
        if (this.state.redirectError404) {
            return (<Redirect to={'/CleanersDashboardError404'} />)
        }
        if (this.state.redirectError500) {
            return (<Redirect to={'/CleanersDashboardError500'} />)
        }
        return (
            <div>
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                <DashboardCleanersHeader />
                {this.state.loading ?
                    <ReusableButton className="showReportsLoading" buttonText="View report" onClick={this.ViewReport}></ReusableButton> :
                    <ReusableButton className="showReports" buttonText="View report" onClick={this.ViewReport} ></ReusableButton>}
                <div className="CleanersType">
                    <div className="CleanersPieChart">
                        <div className="CleanerPieChartInside">
                            <h2>{CleanersDashboardHomeConstant.PieChartHead}</h2>
                            <p>{CleanersDashboardHomeConstant.PieChartPara}</p>
                            {this.state.redirectNoData ? <div><h5 className="NoDataChartCount">{CleanersDashboardHomeConstant.NoDataAvailable}</h5></div> : null}
                            <div className="DashboardBarChart">
                                <div id="PieChart">
                                    <canvas id="pieChartType"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="CleanerLineChart">
                        <div className="FlexChart">
                            <h2>{CleanersDashboardHomeConstant.MissedCleanerVisits}</h2>
                            <h2 className="CountMissed">{this.state.missedCleans}</h2>
                        </div>
                        <div className="FlexChart">
                            {/* <p>{CleanersDashboardHomeConstant.MissedCleanerVisitsP}</p> */}
                            <div className="MissedInformation">
                                {this.state.highValueDisplay ?
                                    <div className="missedIcon">
                                        {this.state.flagDiffMissedClean ?
                                            <span className="diffClean"><IoMdArrowRoundUp className="ArrowIconUp" size={28} />{this.state.diffMissedClean}{" in the previous period"}</span> :
                                            <span className="diffClean"><IoMdArrowRoundDown className="ArrowIcon" size={28} />{this.state.diffMissedClean}{" in the previous period"}</span>}
                                    </div> :
                                    <div className="missedIcon">
                                        {this.state.flagDiffMissedClean ?
                                            <span className="diffClean"><IoMdArrowRoundUp className="ArrowIconUp" size={28} />{"+ "}{this.state.diffMissedClean}{"% in the previous period"}</span> :
                                            <span className="diffClean"><IoMdArrowRoundDown className="ArrowIcon" size={28} />{this.state.diffMissedClean}{"% in the previous period"}</span>}
                                    </div>}
                            </div>
                        </div>
                        <div id="LineGraphChart">
                            <canvas id="lineChartType" width="400" height="250"></canvas>
                        </div>
                    </div>
                </div>
                <div className="CleanersDataTabs">
                    <div className="DashboardMenu">
                        <div className="menu" >
                            <div className="headerMenu">
                                <ul className="CleanersNavTab" >
                                    <li className="AttendedCleanersNavTab">{CleanersDashboardHomeConstant.AttendedClean}</li>
                                    <li className="MissedCleanersNavTab">{CleanersDashboardHomeConstant.MissedClean}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* /* Success Cleans DataTable */}
                    <div id="AttendedClean">
                        <div className="SearchCSV">
                            <ReusableTextBox type="text" onChange={this.handleChangeSearch} className="SearchText" onKeyPress={this.handleSearchEnter} placeholder={CleanersDashboardHomeConstant.Placeholder} />
                            {this.state.loading ?
                                <IoMdSearch className="searchiconLoading" onClick={this.handleSearch} /> :
                                <IoMdSearch className="searchicon" onClick={this.handleSearch} />}
                            {this.state.loading ?
                                <ReusableButton className="DownloadCSVLoading" buttonText={CleanersDashboardHomeConstant.DownloadCSV} onClick={this.downloadCSV} disabled={(this.state.downloadCSVdisable)}></ReusableButton> :
                                <ReusableButton className="DownloadCSV" buttonText={CleanersDashboardHomeConstant.DownloadCSV} onClick={this.downloadCSV} disabled={(this.state.downloadCSVdisable)}></ReusableButton>}
                        </div>
                        <div className="Datatable">
                            <div>
                                <div className="searchDataTable">
                                    <table id="example" className="display" width="100%">
                                        <thead>
                                            <tr>
                                                <th>{CleanersDashboardHomeConstant.Store}</th>
                                                <th>{CleanersDashboardHomeConstant.Visitor}</th>
                                                <th>{CleanersDashboardHomeConstant.PurposeVisit}</th>
                                                <th>{CleanersDashboardHomeConstant.Compliance}</th>
                                                <th>{CleanersDashboardHomeConstant.Date}</th>
                                                <th>{CleanersDashboardHomeConstant.TimeIn}</th>
                                                <th>{CleanersDashboardHomeConstant.TimeOut}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div className="ReactPaginate">
                                        <ReactPaginate
                                            previousLabel={'Prev'}
                                            nextLabel={'Next'}
                                            breakLabel={'...'}
                                            breakClassName={'break-me'}
                                            pageCount={this.pageCount}
                                            onPageChange={this.handlePageChange}
                                            marginPagesDisplayed={3}
                                            pageRangeDisplayed={3}
                                            containerClassName={'pagination'}
                                            activeClassName={'active'}
                                            pageClassName={'paginationLink'}
                                            forcePage={this.state.Page - 1}
                                        />
                                    </div>
                                    {this.state.paginationNoDisplay ? null :
                                        <div className="PageDescription">
                                            <p>{CleanersDashboardHomeConstant.ShowingPage} {this.state.Page} {CleanersDashboardHomeConstant.Of} {this.pageCount}</p>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /* Missed Cleans DataTable */}
                    <div id="MissedClean">
                        <div></div>
                        <div className="SearchCSV">
                            <ReusableTextBox type="text" role="textbox" className="SearchText" onChange={this.handleChangeSearchMissedCleans} onKeyPress={this.handleSearchEnterMissedCleans} placeholder={CleanersDashboardHomeConstant.PlaceholderMissedCleans} />
                            {this.state.loading ?
                                <IoMdSearch className="searchiconLoading" onClick={this.handleSearchMissedCleans} /> :
                                <IoMdSearch className="searchicon" onClick={this.handleSearchMissedCleans} />}
                            {this.state.loading ?
                                <ReusableButton className="DownloadCSVLoading" buttonText={CleanersDashboardHomeConstant.DownloadCSV} onClick={this.downloadCSVMissedCleans} disabled={(this.state.downloadCSVdisableMissed)}></ReusableButton> :
                                <ReusableButton className="DownloadCSV" buttonText={CleanersDashboardHomeConstant.DownloadCSV} onClick={this.downloadCSVMissedCleans} disabled={(this.state.downloadCSVdisableMissed)}></ReusableButton>}
                        </div>
                        <div className="Datatable">
                            <div>
                                <div className="searchDataTable">
                                    <table id="exampleMissedClean" className="display" width="100%">
                                        <thead>
                                            <tr>
                                                <th>{CleanersDashboardHomeConstant.HubId}</th>
                                                <th>{CleanersDashboardHomeConstant.HubName}</th>
                                                <th>{CleanersDashboardHomeConstant.SupplierName}</th>
                                                <th>{CleanersDashboardHomeConstant.Date}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div className="ReactPaginate">
                                        <ReactPaginate
                                            previousLabel={'Prev'}
                                            nextLabel={'Next'}
                                            breakLabel={'...'}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCountMissedCleans}
                                            onPageChange={this.handlePageChangeMissedCleans}
                                            marginPagesDisplayed={3}
                                            pageRangeDisplayed={3}
                                            containerClassName={'pagination'}
                                            activeClassName={'active'}
                                            pageClassName={'paginationLink'}
                                            forcePage={this.state.PageMissedCleans - 1}
                                        />
                                    </div>
                                    {this.state.paginationNoDisplayMissedCleans ? null :
                                        <div className="PageDescription">
                                            <p>{CleanersDashboardHomeConstant.ShowingPage} {this.state.PageMissedCleans} {CleanersDashboardHomeConstant.Of} {this.state.pageCountMissedCleans}</p>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }



}
export default CleanersDashboardHome;